import { cn } from "@/lib/cn";

interface WordmarkProps {
  className?: string;
  /** Show "Mail Assistant" tagline below the Oprentis word. */
  withTagline?: boolean;
}

/**
 * Oprentis wordmark, with optional "Mail Assistant" sub-line.
 * Placeholder until a real SVG logo arrives — text is fine for v1.
 */
export function Wordmark({ className, withTagline = true }: WordmarkProps) {
  return (
    <div className={cn("flex flex-col items-center gap-1", className)}>
      <span className="font-serif text-3xl tracking-tight text-op-primary">
        Oprentis
      </span>
      {withTagline ? (
        <span className="text-sm uppercase tracking-[0.18em] text-op-secondary">
          Mail Assistant
        </span>
      ) : null}
    </div>
  );
}
